import * as React from 'react';
import {OuterURL} from 'src/config/view_const/outer_url';
import styled from 'styled-components'
import {ConstBreakPoint, ConstColor, ConstHeight, ConstZIndex} from "../../../config/styles_const/styles_const";
import OuterLink from '../atom/outer_link';
import Paragraph from '../atom/text/paragraph';

interface IProps {
}

const DashboardNotification: React.FC<IProps> = (props) => {

    return (
        <Wrapper>
            <OuterLink href={OuterURL.calendlyURL} target="_blank" rel="noopener">
                <DashboardNotificationWrapper>
                    <NotificationText bold={true}>まだ面談が未調整の方は、こちら</NotificationText>
                    <Paragraph icon={'"\f24d"'} iconPrefix={"400"} />
                </DashboardNotificationWrapper>
            </OuterLink>
        </Wrapper>
    );

};

export default DashboardNotification;

const Wrapper = styled.div`
    position: sticky;
    top: ${ConstHeight.HeaderHeightSp};
    right: 0;
    left: 0;
    z-index: ${ConstZIndex.notificationCenter};
    color: ${ConstColor.White};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        top: 0;
    };
`

const DashboardNotificationWrapper = styled.div`
    height: 60px;
    display: flex;
    align-items: center; 
    justify-content: center;
    color: ${ConstColor.White};
    background-color: ${ConstColor.NoticeInfo};
    animation: show 1s both;
    
    @keyframes show {
        0% {
            opacity: 0; 
            transform: translate3d(0,-20px,0);
        };
        100% {
            opacity: 1; 
            transform: translate3d(0,0,0);
        };
    };
`

const NotificationText = styled(Paragraph)`
    margin-right: 10px;
`


// WEBPACK FOOTER //
// ./src/presentation/common/organism/dashboard_notification.tsx